import React from 'react';

const WhatIOffer = () => {
  const services = [
    { 
      title: "Primary English Tuition", 
      icon: "📚",
      description: "Foundation skills for young learners"
    },
    { 
      title: "Secondary/GCSE Tuition", 
      subtitle: "(AQA and Edexcel Exam Boards)", 
      icon: "🎓",
      description: "Exam preparation and coursework support"
    },
    { 
      title: "A Level English", 
      icon: "📖",
      description: "Advanced literature and language analysis"
    },
    { 
      title: "Degree English & Dissertation Help", 
      icon: "🎯",
      description: "University-level academic support"
    }
  ];

  return (
    <section className="section-padding bg-white">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-black mb-12 text-center">
          What I Offer
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="card bg-beige p-8 rounded-2xl text-center hover:bg-beige-dark transition-colors"
            >
              <div className="text-5xl mb-4">{service.icon}</div>
              <h3 className="text-xl font-semibold text-black mb-2">
                {service.title}
              </h3>
              {service.subtitle && (
                <p className="text-sm text-black opacity-70 mb-3">
                  {service.subtitle}
                </p>
              )}
              <p className="text-sm text-black opacity-80">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatIOffer;